module.exports = __webpack_public_path__ + "static/media/logo.b92b11c3.svg";